export default "__VITE_ASSET__69lfypzv__"